import { render, staticRenderFns } from "./CreateWordModal.vue?vue&type=template&id=e5306644"
import script from "./CreateWordModal.vue?vue&type=script&lang=js"
export * from "./CreateWordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports